export default {
    root: {
        class: [
            // Flexbox
            "relative flex flex-col",
        ],
    },
    contentContainer: {
        class: [
            // Flexbox & Overflow
            "flex flex-col overflow-auto",
        ],
    },
    content: ({props}) => ({
        class: [
            // Flexbox
            "flex",

            // Orientation
            {
                "flex-row": props.orientation !== "vertical",
                "flex-col": props.orientation == "vertical",
            },
            ,
            "[&>[data-pc-extend=button]]:self-center",
        ],
    }),
    viewport: {
        class: [
            // Overflow & Width
            "overflow-hidden w-full",
        ],
    },
    itemList: ({props}) => ({
        class: [
            // Flexbox
            "flex",

            // Orientation & Sizing
            {
                "flex-row": props.orientation !== "vertical",
                "flex-col h-full": props.orientation == "vertical",
            },
        ],
    }),
    item: ({props}) => ({
        class: [
            // Flexbox
            "flex shrink-0 grow",

            // Size
            {
                // "w-full sm:w-[50%] md:w-[33.333333333333336%]": props.orientation !== "vertical",
                "w-full": props.orientation !== "vertical",

                "w-full h-full": props.orientation == "vertical",
            },
        ],
    }),
    itemClone: ({props}) => ({
        class: [
            // Flexbox
            "flex shrink-0 grow",
            "unvisible",

            // Size
            {
                // "w-full sm:w-[50%] md:w-[33.333333333333336%]": props.orientation !== "vertical",
                "w-full": props.orientation !== "vertical",

                "w-full h-full": props.orientation == "vertical",
            },
        ],
    }),
    indicatorList: {
        class: [
            // Flexbox & Alignment
            "flex flex-row justify-center flex-wrap",
        ],
    },
    indicator: {
        class: [
            // Spacing
            "mr-2 mb-2",
        ],
    },
    indicatorButton: ({context}) => ({
        class: [
            // Sizing & Shape
            "w-8 h-2 rounded-md",

            // Transitions
            "transition duration-200",

            // Focus Styles
            "focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green-400/50 dark:focus:ring-askr-green-300/50",

            // Color & Background
            {
                "bg-stone-200 hover:bg-stone-300 dark:bg-stone-700 dark:hover:bg-stone-600": !context.highlighted,
                "bg-askr-green hover:bg-askr-green-300": context.highlighted,
            },
        ],
    }),
    pcPrevButton: {
        root: {
            class: [
                "absolute left-2 top-0 bottom-0 z-10 bg-stone-50 text-black rounded-full w-10 h-10 flex items-center justify-center [&_[data-pc-section=label]]:hidden hover:brightness-90 transition duration-200 cursor-pointer",
            ],
        },
    },
    pcNextButton: {
        root: {
            class: [
                "absolute right-2 top-0 bottom-0 z-10 bg-stone-50 text-black rounded-full w-10 h-10 flex items-center justify-center [&_[data-pc-section=label]]:hidden hover:brightness-90 transition duration-200 cursor-pointer",
            ],
        },
    },
};
